import { useMutation, useQuery } from '@apollo/client';
import {
  CREATE_SUBSCRIPTION_V2,
  ORDER_WITH_PROMO_TOTAL,
  UPDATE_SUBSCRIPTION_V2,
} from '@graphql/mutations/orderFlow';
import { GET_SIDE } from 'src/http/planAndFreq';

export const useOrderTotalMutation = () => {
  const [getOrderTotal, { loading, error, data }] = useMutation(
    ORDER_WITH_PROMO_TOTAL
  );

  return {
    getOrderTotal,
    loading,
    error,
    data,
  };
};

export const useCreateSubscriptionMutation = () => {
  const [createSubscriptionV2, { loading, error, data }] = useMutation(
    CREATE_SUBSCRIPTION_V2
  );

  return {
    createSubscriptionV2,
    loading,
    error,
    data,
  };
};

export const useUpdateSubscriptionMutationV2 = () => {
  const [updateSubscriptionV2, { loading, error, data }] = useMutation(
    UPDATE_SUBSCRIPTION_V2
  );

  return {
    updateSubscriptionV2,
    loading,
    error,
    data,
  };
};

export const useGetSideDetailQuery = ({ countryCode, isSkipped }: any) => {
  try {
    const { data } = useQuery(GET_SIDE, {
      variables: {
        input: {
          countryCode,
          filters: {
            type: 'SIDE',
          },
        },
      },
      skip: !countryCode || isSkipped,
      fetchPolicy: 'cache-and-network',
    });
    return data?.getPlansAndFrequencies?.plans[0][0];
  } catch (err) {
    console.log(err);
    return null;
  }
};
